export default {
  mediationList: {
    max: {}
  }
}
